<div class="dialoghead">
  <h1 class="mat-mdc-dialog-title">{{cookieData?.userinfo?.mystery_school_status && cookieData?.userinfo?.mystery_school_status !== 'subscription running' ? 'Subscription Expired' : 'Payment'}}</h1>
  <mat-dialog-content *ngIf="cookieData?.userinfo?.mystery_school_status && cookieData?.userinfo?.mystery_school_status !== 'subscription running'">
    <p>Your subscription to <strong>The Mystery School</strong> ended on <strong>{{ cookieData?.userinfo?.mystery_current_period_end | date:'EEEE, MMMM d, y' }}</strong>.
      <br>To regain access to your dashboard, its transformative training in astrology, tarot, and theurgy, engaging live sessions, collaborative student readings, direct guidance from expert instructors, and all other member resources, please renew your subscription below.</p>
</mat-dialog-content>
  <mat-dialog-content>
  <form *ngIf="mode === 'payment'" (submit)="handleSubmit($event)">
    <div id="mystery-payment-element" class="mystery_payment_form"></div>
    <mat-dialog-actions>
      <button mat-button type="submit">Pay & Subscribe</button>
    </mat-dialog-actions>
    <ng-container *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
  </form>
   <form *ngIf="mode === 'setup'" (submit)="handleSetupSubmit($event)">
    <div id="mystery-payment-element" class="mystery_payment_form"></div>
    <mat-dialog-actions>
      <button mat-button type="submit">Pay & Subscribe</button>
    </mat-dialog-actions>
    <ng-container *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
  </form>
  <div *ngIf="mode === 'noClientSecret'">
  <p>You already have access until {{ cookieData.userinfo.mystery_current_period_end | date:'mediumDate' }}.
    Your subscription has been renewed and will continue without interruption.</p>
</div>

<div *ngIf="!mode">
    <p>Initializing payment form...</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
</mat-dialog-content>
</div>
